import { Extension } from '@tiptap/core';

import getFormFieldLinePlugin from '../plugins/getFormFieldLinePlugin';
import { FORM_FIELD_LINE_NODE_NAME } from '../nodes/formField/constants';

/** The line's input and paste guard, in an extension of its own so its priority leaves the schema order alone. */
const FormFieldLineGuard = Extension.create({
  name: 'formFieldLineGuard',
  // Ahead of Link (1000) and the image paste, whose paste handlers would otherwise take a paste on the line first.
  priority: 1001,

  addProseMirrorPlugins() {
    return [getFormFieldLinePlugin(this.editor.schema.nodes[FORM_FIELD_LINE_NODE_NAME])];
  },
});

export default FormFieldLineGuard;
